<div class="canned-service-browse">
  <div class="canned-service-browse-header">
    <div class="flex-start-end">
      <!-- Canned Service Browse Header -->
      <div class="flex-between-center width-100p pb-0">
        <p class="mb-0 font-14 font-bold">Service lookup</p>

        <div class="text-right">
          <i id="canned-service-dialog-close" class="fal fa-times pointer ml-4" (click)="handleClose()"></i>
        </div>
      </div>
      <!-- Canned Service Browse Header -->
    </div>
  </div>

  <div class="canned-service-browse-wrapper">
    <div class="ui-g p-0">
      <div class="ui-g-12 p-0 flex-start-center no-create-m-vehicle mb-2 mt-4">
        <i class="far fa-car font-14 font-45 pr-2"></i>
        <div class=" p-0 input-field" [ngClass]="{'ui-g-7': isCarfaxEnabled,'ui-g-12': !isCarfaxEnabled}">
          <app-auto-complete id="ac-vehicle" listId="ac-vehicle-list" label="VIN or year, make, model" itemWidth="575px"
            theme="primary" noRecordIcon="fal fa-car font-16 pr-2" noRecordText="No vehicle match your search"
            placeholder="VIN or year, make, model" [textTruncate]="true" [fontSize]="14"
            [suggestions]="vehicleSuggestions" [floatingLabel]="true" [autoFocus]="true"
            [isLoading]="isVehicleSearching" [value]="vehicleQuery"
            (appSelect)="onVehicleSelect($event)" (appCompletedMethod)="onSearchVehicle($event)" scrollHeight="186px">
            <ng-template let-item appTemplate="item">
              <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                <div class="flex-between-center">
                  <p class="m-0" [innerHTML]="item?.htmlName"></p>
                  <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                    [innerHTML]="item?.htmlLicensePlate">
                  </p>
                </div>

                <div class="flex-between-center">
                  <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                  <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin"></p>
                </div>
              </div>
            </ng-template>
          </app-auto-complete>
        </div>

        <div class="ui-g-5 p-0 pb-7px input-field carfax-reg-state-field" *ngIf="isCarfaxEnabled">
          <app-dropdown theme="primary" hPosition="left" scrollHeight="215px" styleClassSelectedView="p-0 mt-5px"
            inactiveItemsKey="stateCode" [selectInactiveItems]="false" [focusOnSelectedValue]="false" [options]="states"
            [isDropdownIconVisible]="false" [hasCustomOpenTemplate]="true" [hasCustomItemTemplate]="true"
            [hasListHeader]="false" (appSelect)="onStateSelect($event, true)">
            <ng-template let-item appTemplate="open-dropdown-btn">

              <div class="flex-center-center font-14 text-truncate">
                Registration&nbsp;state: <span class="font-600 font-primary pl-2 text-truncate">
                  {{vehicle?.state || defaultRegState}}
                </span>
              </div>
            </ng-template>

            <ng-template let-item appTemplate="item">
              <div [hidden]="item?.isHeader" class="p-2 font-secondary-700">{{item?.stateCode}} - {{item?.state}}</div>
              <div [hidden]="!item?.isHeader" class="p-2 font-gray-55 font-600 item-country-header">{{item?.country}}
              </div>
            </ng-template>
          </app-dropdown>
        </div>
      </div>

      <div class="ui-g-12 p-0 mt-1">
        <div class="canned-service-search-input pb-0">
          <app-input leftIcon="fal fa-search" theme="border"
            [placeholder]="activeTabIndex === 4? 'Search codes': 'Search all services'"
            id="canned-service-dialog-search" [fontSize]="14" [value]="query" [hasActions]="!!query?.length"
            (appChange)="searchCannedServices($event)" [saveIcon]="null" (appBlur)="isSearchFieldFocused = false"
            (appCancel)="_searchCannedServices('')">
          </app-input>
        </div>
      </div>
    </div>

    <div class="ui-g service-tab-wrapper p-0">
      <div class="ui-g-12 flex-between-center p-0">
        <div class="flex-start-center">
          <p class="service-tab motor-tab flex-row flex-center-center font-14 font-600 text-center m-0 pointer p-3"
            [ngClass]="{ 'active': activeTabIndex === 0 }" (click)="handleSelectTab(0)">
            <img src="../../../../assets/img/motor-icon-sm.ico" class="motor-icon" alt="motor">
            Services
          </p>

          <p class="service-tab maintenance-tab flex-row flex-center-center font-14 font-600 text-center m-0 pointer p-3"
            [ngClass]="{ 'active': activeTabIndex === 1 }" (click)="handleSelectTab(1)">
            <img src="../../../../assets/img/motor-icon-sm.ico" class="motor-icon" alt="motor">
            Maintenance
          </p>

          <p *ngIf="isRepairDiagramEnabled"
            class="service-tab code-tab flex-row flex-center-center font-14 font-600 text-center m-0 pointer p-3"
            [ngClass]="{ 'active': activeTabIndex === 2 }" (click)="handleSelectTab(2)">
            <img src="../../../../assets/img/motor-icon-sm.ico" class="motor-icon" alt="motor">
            Code
          </p>
        </div>

        <div class="flex-end-center" *ngIf="vehicle?.vehicleId && !motorVehicleId && isMotorServiceEnabled">
          <i class="fal fa-exclamation-triangle font-red font-600 pr-2"></i>

          <p class="m-0 pr-2">
            Vehicle <span class="font-600">{{vehicle?.name}}</span> is not linked
          </p>

          <button class="btn btn-white mr-2" (click)="openVehicleInSidepanel($event, true)">Connect to MOTOR</button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTabIndex === 0 && isMotorServiceEnabled">
    <app-motor-service-enhanced class="ui-g motor-service canned-service-browse-body" [isServiceLookup]="true"
      [isRepairDiagramEnabled]="isRepairDiagramEnabled" [pricings]="pricings" [itemSettings]="itemSettings"
      [query]="query" [orderStatus]="orderStatus" [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId"
      [isMotorServiceEnabled]="isMotorServiceEnabled">
    </app-motor-service-enhanced>
  </div>

  <div *ngIf="activeTabIndex === 1 && isMotorServiceEnabled" class="maintainance-service canned-service-browse-body">
    <app-maintainance-services class="ui-g p-0 motor-service canned-service-browse-body" [isServiceLookup]="true"
      [mileage]="mileage" [vehicle]="vehicle" [pricings]="pricings" [itemSettings]="itemSettings" [query]="query"
      [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId" [isMotorServiceEnabled]="isMotorServiceEnabled">
    </app-maintainance-services>
  </div>

  <div *ngIf="activeTabIndex === 2 && isMotorServiceEnabled && isRepairDiagramEnabled"
    class="code-service canned-service-browse-body">
    <app-troubleshoot-code *ngIf="motorVehicleId" class="ui-g p-0 motor-service canned-service-browse-body"
      [isServiceLookup]="true" [query]="query" [motorVehicle]="motorVehicle" [motorVehicleId]="motorVehicleId">
    </app-troubleshoot-code>
  </div>

  <!-- Canned Service Footer -->
  <div class="ui-g-12 canned-service-browse-footer flex-end-center p-2" *ngIf="activeTabIndex!== 4">
    <button id=" canned-service-btn-done" class="btn btn-primary btn-80 btn-12 font-14" (click)="handleClose()">
      Done
    </button>
  </div>
  <!-- Canned Service Footer -->
</div>
